<template>
  <div class="bg-[#23242A] text-white h-screen app-header pt-0 p-3 custom">
    <div :class="'p-3 pt-0 flex content-main h-full overflow-y-auto d-scroll ' + (action.component ? ' half-it gap-5' : 'gap-5')">
      
      <div class="custom-full custom-left">
        
        <div class="bg-[#2B2C32] rounded-lg px-[16px] max-w-full py-[16px]">
          <template v-if="vg_selectedLocation.id">
            <div class="flex justify-between mb-5 h-[40px]">
              <h2 class="text-[24px] font-semibold text-white">Featured Categories</h2>
               <mdicon @click="addUpdate({ component: 'Add', data: {}})" v-if="!action.component && can_edit_categories" size="32" name="plus" class="text-white bg-theme-green hover:bg-theme-darkgreen py-1 h-10 px-1 text-2xl border-0 rounded-md cursor-pointer"/>
              <!-- <button @click="addUpdate({ component: 'Add', data: {}})" v-if="!action.component" class="text-white bg-green-500 py-2 px-3 text-3xl border-0 rounded-md cursor-pointer">
                <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.49935 19.3327V10.9993H0.166016V8.99935H8.49935V0.666016H10.4993V8.99935H18.8327V10.9993H10.4993V19.3327H8.49935Z" fill="white"/>
                </svg>
              </button> -->
            </div>
            <List @toggleEdit="selectedItem" @clearComponent="clearComponent" :iscomponentactive="action.component ? true : false"/>
          </template>

          <p v-else class="text-center text-theme-red">Please select a location from the top left corner.</p>

        </div>
      </div>
  
      <div :class="'w-full hidden-component custom-right'" v-if="action.component" >
        <component :is="action.component" :item="action.data" @clearComponent="clearComponent"></component>
      </div>

    </div>
  </div>
</template>


<script lang="ts">
import {defineComponent, ref} from "vue"
import { mapGetters, mapActions } from "vuex";
import List from '@/views/Products/Category/FeaturedCategory/List.vue';
import Add from '@/views/Products/Category/FeaturedCategory/Add.vue';
import Update from '@/views/Products/Category/FeaturedCategory/Update.vue';
import Helpers from '@/helpers';

  export default defineComponent({
  name: "ProductCategories",
  components: {

    List,
    Add,
    Update,
  },

  setup() {
    const action = ref<object>({
      component: '',
      data: {},
    });
    return {
      action,
    };
  },

   watch: {
    'vg_selectedLocation'(val) {
      // if location selected clear component
      this.clearComponent();
    },
  },

  computed: {
    /**
     * Edit restriction
     */
     can_edit_categories() {
      return Helpers.getMyPermission('can_edit_categories')
    },

    ...mapGetters({
     vg_selectedLocation: 'location/selected'
    }),
  },

  mounted() {
    this.emitter.on("reset-product-featuredcategories-component", data => {
      this.clearComponent();
    });
  },

  beforeDestroy() {
    this.emitter.off('reset-product-featuredcategories-component', () => {});
    this.emitter.off('refresh-product-featuredcategories-list', () => {});
  },
 
  methods: {
    /**
     * Clear action
     */
    clearComponent() {
      this.action = {
        component: '',
        data: {},
      };
      let activeItem = document.getElementsByClassName('active-row');
      if(activeItem.length > 0){
        activeItem[0].classList.remove("active-row");
      }
    },

    /**
     * Change add / update component
     */
    addUpdate(val: any) {
      this.action = val;
    },

    /**
     * Capture selected item
     */
    selectedItem(item) {
      this.addUpdate({
        component: 'Update', 
        data: item
      })
    },

    ...mapActions({
      va_spinner: 'spinner/setSpinner',
    })
  },
});

</script>